<template>
<div class="modal" v-show="value" style="position:fixed;top:0;left:0;width:100%;min-height:100vh;overflow-y:auto;">
    <div style="background:#fff;width:95%;margin:0 auto;padding:1rem;border-radius:5px;max-height:100vh;">
        <v-icon @click.prevent="close" style="position:absolute;right:20px;top:0px;cursor:pointer;font-weight:700;">close</v-icon>

        <v-text-field label="Search Brand" v-model="searchBrand" placeholder="Placeholder" outlined></v-text-field>
        <v-checkbox v-for="item in filterItems" :key="item.brands" v-model="selectedBrands" :label="item.brands" :value="item.brands"></v-checkbox>
    </div>
</div>
</template>

<script>
import axios from "axios"
import ApiList from './ApiList'
export default {
    name: 'Modal',
    props: {
        value: {
            required: true
        }
    },
    mixins: [ApiList],
    data() {
        return {
            apiPath: '',
            param : '',
            searchBrand: '',
            selectedBrands: [],
            brands:[],
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.apiPath = this.apis.brandsURL
            this.param = {
                params: {
                    token: localStorage.token
                }
            }
            
            this.newUrl = this.apis.apiUrl + this.apiPath
            // this.param = {params:{}}
            axios.get(this.newUrl,this.param)
                .then((response) => {
                    // console.log(response)
                    this.brands = []
                    this.brands = response.data
                   
                })
        },
        close() {
            this.$emit("modalSucess", {x:!this.value,y:this.selectedBrands});
            // alert("hiiii")
        },
        // check(){
        //   alert(this.selectedBrands)
        // }
    },
    computed: {
        filterItems: function () {
            if (this.searchBrand == null)
                return this.brands;

            return this.brands.filter((item) => {
                return (item.brands.toLowerCase().match(this.searchBrand.toLowerCase()));
            });
        },
    },
}
</script>

<style lang="css" scoped>
.modal {
    padding: 20px;
    z-index: 999999;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 10px;
    ;
}
</style>
